import { Button, Center, Paper, Stack, Text, Title } from '@mantine/core';
import { sl } from '@reditelji/shared/i18n';
import type { ApiRequestError } from '../api/client';

export interface ErrorFallbackProps {
  error?: Error;
  resetError?: () => void;
}

export function ErrorFallback({ error }: ErrorFallbackProps) {
  const requestId = (error as ApiRequestError | undefined)?.requestId;

  return (
    <Center mih="100vh" p="md" bg="var(--mantine-color-body)">
      <Paper shadow="sm" radius="md" p="xl" withBorder maw={480} w="100%" ta="center">
        <Stack gap="md" align="center">
          <Title order={2} size="h3" fw={700}>
            {sl['error.boundary.title']}
          </Title>
          <Text size="sm" c="dimmed">
            {sl['error.boundary.body']}
          </Text>
          {requestId && (
            <Text size="xs" c="dimmed" ff="monospace">
              {sl['error.boundary.requestId']} {requestId}
            </Text>
          )}
          <Button
            variant="filled"
            color="dark"
            onClick={() => window.location.reload()}
            mt="xs"
          >
            {sl['error.boundary.reload']}
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}
